import { createAction } from "@reduxjs/toolkit"
import { CalculationProcessStep } from "store/types/assembler"

export const calculationProcessStepConstants = {
    SAGA_BUILD_PROCESS_STEP: "SAGA_BUILD_PROCESS_STEP",
    SAGA_GET_PROCESS_STEP_LISTING: "SAGA_GET_PROCESS_STEP_LISTING",
    SAGA_GET_PROCESS_STEP: "SAGA_GET_PROCESS_STEP",
    SAGA_CREATE_PROCESS_STEP: "SAGA_CREATE_PROCESS_STEP",
    SAGA_SAVE_PROCESS_STEP: "SAGA_SAVE_PROCESS_STEP",
    SAGA_DELETE_PROCESS_STEP: "SAGA_DELETE_PROCESS_STEP",
    SAGA_RENAME_PROCESS_STEP: "SAGA_RENAME_PROCESS_STEP"
    }

export const  sagaBuildCalculationProcessStepAction = () => {
    return { type: calculationProcessStepConstants.SAGA_BUILD_PROCESS_STEP
    }
}

export const  sagaGetCalculationProcessStepListingAction = () => {
    return { type: calculationProcessStepConstants.SAGA_GET_PROCESS_STEP_LISTING
    }
}

  export const sagaGetCalculationProcessStepAction = createAction<{
    uuid: string;
  }>(calculationProcessStepConstants.SAGA_GET_PROCESS_STEP);

  export const sagaDeleteCalculationProcessStepAction = createAction<{
    uuid: string;
  }>(calculationProcessStepConstants.SAGA_DELETE_PROCESS_STEP);


  
export const sagaCreateCalculationProcessStepAction = createAction<{
    name: string;
  }>(calculationProcessStepConstants.SAGA_CREATE_PROCESS_STEP);

  export const sagaSaveCalculationProcessStepModelAction = createAction<{
    name: string,
    model: CalculationProcessStep
  }>(calculationProcessStepConstants.SAGA_SAVE_PROCESS_STEP);


  export const sagaRenameCalculationProcessStepAction = createAction<{
    uuid: string;
    name: string
  }>(calculationProcessStepConstants.SAGA_RENAME_PROCESS_STEP);